import { showAlert } from "../components/common/ErrorAlert/ErrorAlert";
import api from "./api";

export async function getCustomers(id = null, params = {}) {
  const url = id ? `customer/?id=${id}` : "customer/";
  const config = id ? {} : { params };

  const response = await api.get(url, config);
  return response.data;
}

export async function getCustomerStatement(id, params = {}) {
  const url = `customer/statement/${id}/`;
  const response = await api.get(url, { params });
  return response.data;
}

export async function getVendorStatement(id, params = {}) {
  const url = `customer/vendor-statement/${id}/`;
  const response = await api.get(url, { params });
  return response.data;
}

export async function getCustomerlist(id = null, params = {}) {
  const url = id ? `customer/?id=${id}` : "customer/grouped/";
  const config = id ? {} : { params };

  const response = await api.get(url, config);
  return response.data;
}

export async function getCustomerDetails(uuid) {
  try {
    const response = await api.get(`customer/${uuid}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CustomerAdd(formData) {
  try {
    const response = await api.post("customer/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function CustomerEdit(id, formData) {
  try {
    const response = await api.put(`customer/?id=${id}`, formData);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function CustomerDelete(id) {
  try {
    const response = await api.delete(`customer/delete/?id=${id}`);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

// export async function ChangeProfilePic(formData) {
//   try {
//       const data = new FormData();
//       data.append("image", formData.image);

//       const response = await api.put(`customer/?id=${formData.id}`, data, {
//           headers: {
//               'Content-Type': 'multipart/form-data',
//           }
//       });

//       return response;
//   } catch (error) {
//       console.log("Error updating profile picture:", error);
//   }
// }

export async function CustomerAddAll(formData) {
  try {
    const response = await api.post("customer/create/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    showAlert(error.response?.data.message);
  }
}

export async function CustomerFullSaveAPI(id, formData) {
  try {
    const response = await api.patch(
      `customer/save/?customer_id=${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function CustomerAddressAdd(formData) {
  try {
    const response = await api.post("customer/address/", formData);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function CustomerAddressEdit(id, formData) {
  try {
    const response = await api.put(`customer/address/?id=${id}`, formData);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function CustomerAddressDelete(id) {
  try {
    const response = await api.delete(`customer/address/?id=${id}`);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function CustomerArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("customer/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`customer/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function duplicateCustomer(customerId) {
  const response = await api.post(`customer/duplicate/?id=${customerId}`);
  return response.data;
}

export async function getAllContactPersons(id = null, params = {}) {
  const url = id
    ? `customer/contact-person/?id=${id}`
    : "customer/contact-person/";
  const config = id ? {} : { params };

  const response = await api.get(url, config);
  return response.data;
}

export async function ContactPersonsDelete(id) {
  try {
    const response = await api.delete(`customer/contact-person/?id=${id}`);
    return response;
  } catch (error) {
    // console.log("Error getting Document",error)
  }
}

export async function ContactPersonArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("customer/contact-person/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`customer/contact-person/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    // console.log("Error Archiving Attribute: ", error);
  }
}

export async function getAddress(customer_id, address_type = "", id = null) {
  try {
    let url = `customer/address/?customer_id=${customer_id}`;

    if (address_type) {
      url += `&address_type=${address_type}`;
    }
    if (id) {
      url = `customer/address/?id=${id}`;
    }

    const response = await api.get(url);
    return response;
  } catch (error) {
    console.error("Error getting address:", error);
  }
}

//Active options
export async function ActiveVendors() {
  const params = { partner_type: "vendor" };
  try {
    const response = await api.get("customer/active/", { params });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function ActiveCustomers() {
  const params = { partner_type: "customer" };
  try {
    const response = await api.get("customer/active/", { params });
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ActiveUsers() {
  try {
    const response = await api.get("accounts/users/organizational/active/");
    return response;
  } catch (error) {
    console.log(error);
  }
}

//salesOrder

export async function getSalesDetails(uuid) {
  try {
    let response;
    response = await api.get(`sales/order/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getQuotationDetails(uuid) {
  try {
    let response;
    response = await api.get(`sales/quotation/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getSalesList(params = {}) {
  try {
    let response;
    response = await api.get("sales/list/", {
      params: { ...params },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getQuotationList(params = {}) {
  try {
    let response;
    response = await api.get("sales/quotation/list/", {
      params: { ...params },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CreateSalesOrder(formData) {
  try {
    const response = await api.post("sales/create/", formData);
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function CreateQuotation(formData) {
  try {
    const response = await api.post("sales/quotation/create/", formData);
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function COnfirmSalesOrder(id) {
  try {
    const response = await api.post(`sales/confirm/${id}/`);
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function CancelSalesOrder(id) {
  try {
    const response = await api.post(`sales/cancel/${id}/`);
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function UpdateSalesOrder(id, formData) {
  try {
    const response = await api.put(`sales/update/?sales_id=${id}`, formData);
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function SalesOrderDelete(id) {
  try {
    const response = await api.delete(`sales/delete/?id=${id}`);
    return response;
  } catch (e) {
    showAlert(e.response.data?.message);
  }
}

export async function duplicateSales(sales_id) {
  const response = await api.post(`sales/duplicate/?id=${sales_id}`);
  return response.data;
}

export async function duplicateQuotations(sales_id) {
  const response = await api.post(`sales/quotation/duplicate/?id=${sales_id}`);
  return response.data;
}

export async function SalesAddressList(params = {}) {
  try {
    const response = await api.get(`sales/address/`, { params });
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function SalesAddressAdd(formData) {
  try {
    const response = await api.post("sales/address/", formData);
    return response;
  } catch (error) {
    console.log("Error adding driver");
  }
}

export async function ArchiveSalesOrder(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("sales/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`sales/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    showAlert(error.response.data?.message);
  }
}

export async function DeliveredSalesOrders() {
  try {
    const response = await api.get("sales/delivered/");

    const orders = response.data || [];

    return orders.map((order) => ({
      label: order.order_id,
      value: order.id,
    }));
  } catch (error) {
    // In production, avoid logging. Optionally use a toast or silent fail.
    return [];
  }
}

//PRICELIST

export async function getPriceList(id = null, params = {}) {
  try {
    if (id) {
      const response = await api.get(`pricelist/?id=${id}`);
      return response.data;
    } else {
      const response = await api.get("pricelist/", { params });
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getPricelistDetails(uuid) {
  try {
    let response;
    response = await api.get(`pricelist/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function PriceListAdd(formData) {
  try {
    const response = await api.post("pricelist/", formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function PriceListCreation(formData) {
  try {
    const response = await api.post("pricelist/create/", formData);
    return response.data;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function duplicatePricelist(price_list_id) {
  const response = await api.post(`pricelist/duplicate/?id=${price_list_id}`);
  return response.data;
}

export async function PriceListEdit(id, formData) {
  try {
    const response = await api.patch(`pricelist/update/?id=${id}`, formData);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PriceListDelete(id) {
  try {
    const response = await api.delete(`pricelist/delete/?id=${id}`);
    return response;
  } catch (e) {
    showAlert(e.response.data.message);
  }
}

export async function PriceListArchive(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("pricelist/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`pricelist/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPriceProductList(price_list = null) {
  try {
    if (price_list) {
      const response = await api.get(
        `pricelist/product/active/?price_list=${price_list}`,
      );
      return response.data.data;
    } else {
      const response = await api.get("pricelist/product/active/");
      return response.data.data;
    }
  } catch (error) {}
}

export async function PriceListProductDelete(id) {
  try {
    const response = await api.delete(`pricelist/product/?id=${id}`);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function ActivePricelist() {
  try {
    const response = await api.get("pricelist/active/");
    return response.data.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getCustomerPriceList(customer_id) {
  try {
    const response = await api.get(
      `customer/find-price_list/?customer_id=${customer_id}`,
    );
    return response.data.data;
  } catch (error) {
    // console.log("Error getting Document",error)
  }
}

//deliveryORdersss

export async function getDeliveryOrders(params = {}) {
  try {
    let response;
    response = await api.get("sales/delivery-order/list/", {
      params: { ...params },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getDeliveryOrderDetails(uuid) {
  try {
    const response = await api.get(`sales/delivery-order/${uuid}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CheckDeliveryExists(sales_id) {
  try {
    const response = await api.get(`sales/check-delivery/`, {
      params: { sales_id: sales_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

// export async function DeliveryOrderAdd(formData) {
//   try{
//     const response = await api.post('sales/delivery-order/',formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

export async function DeliveryOrderDelete(uuid) {
  try {
    const response = await api.delete(`sales/delivery-order/${uuid}/delete/`);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function ArchiveDeliveryOrder(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("sales/delivery-order/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`sales/delivery-order/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

// export async function DeliveryProductAdd(formData) {
//   try{
//     const response = await api.post('sales/delivery-product/',formData);
//     return response
//   }catch(error){
//     console.log(error)
//   }
// }

export async function updateDeliveredQuantity(formData) {
  try {
    const response = await api.put(
      `sales/update-delivered-quantities/`,
      formData,
    );
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function CancelDeliveryOrder(uuid) {
  try {
    const response = await api.post(`sales/delivery-order/${uuid}/cancel/`);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function DeliveryOrderAddWithProducts(formData) {
  try {
    const response = await api.post("sales/delivery-orders/create/", formData);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function DeliveryOrderInitiate(
  deliveryOrderId,
  warehouseId = null,
  locationId = null,
) {
  try {
    const params = { delivery_order_id: deliveryOrderId };
    if (warehouseId) params.warehouse_id = warehouseId;
    if (locationId) params.location_id = locationId;

    const response = await api.get(`sales/delivery-order/initiate/`, {
      params,
    });
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

//SALES RETURN

export async function SalesReturnList(params = {}) {
  try {
    const response = await api.get("sales/return/", {
      params,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getSalesReturnOptions(customer_id) {
  try {
    const response = await api.get(
      `sales/returnable-orders-short/?customer_id=${customer_id}`,
    );
    const orders = response.data?.data || [];

    return orders.map((order) => ({
      label: order.order_id,
      value: order.id,
    }));
  } catch (error) {
    throw error;
  }
}

export async function getSalesReturnDetails(uuid) {
  try {
    const response = await api.get(`sales/return/${uuid}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function CreateSalesReturn(formData) {
  try {
    const response = await api.post("sales/return-order/create/", formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function SalesReturnEdit(id, formData) {
  try {
    const response = await api.put(`sales/return/?id=${id}`, formData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function CancelSalesReturn(uuid) {
  try {
    const response = await api.post(`sales/return/${uuid}/cancel/`);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function ConfirmSalesReturn(uuid) {
  try {
    const response = await api.post(`sales/return/${uuid}/confirm/`);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function SalesReturnUpdate(uuid, formData) {
  try {
    const response = await api.put(`sales/return/${uuid}/update/`, formData);
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function SalesReturnDelete(id) {
  try {
    const response = await api.delete(`sales/return/delete/?id=${id}`);
    return response;
  } catch (e) {
    showAlert(e.response.data.message);
  }
}

export async function ReturnReceiptDelete(uuid) {
  try {
    const response = await api.delete(`sales/return-receipt/${uuid}/delete/`);
    return response;
  } catch (e) {
    showAlert(e.response.data.message);
  }
}

export async function duplicateSalesReturn(return_id) {
  const response = await api.post(`sales/return/duplicate/?id=${return_id}`);
  return response.data;
}

// export async function SalesReturnProductEdit(formData) {
//   try {
//     const response = await api.put(`sales/return/products/`, formData);
//     return response;
//   } catch (error) {
//     console.error("SalesReturnProductEdit Error:", error);
//   }
// }

export async function ArchiveSalesReturn(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("sales/return/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`sales/return/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function updateReturnedQuantity(formData) {
  try {
    const response = await api.put(
      `sales/return/update-returned-quantity/`,
      formData,
    );
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function GetCustomerSalesOrders(customer) {
  try {
    if (!customer) return [];

    const response = await api.get("sales/", {
      params: { customer },
    });

    const orders = response.data?.data;

    return orders.map((order) => ({
      label: order.order_id,
      value: order.id,
    }));
  } catch (error) {
    throw error;
  }
}

export async function CheckReturnableProducts(sales_id) {
  try {
    const response = await api.get(`sales/returnable-products/`, {
      params: { sales_id: sales_id },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function CheckReturnStatus(sales_return) {
  try {
    const response = await api.get(`sales/return/status/?sales_return=${sales_return}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function ReturnReceiptList(params) {
  try {
    const response = await api.get("sales/return-receipt/", {
      params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getReturnReceiptDetails(uuid) {
  try {
    const response = await api.get(`sales/return-receipt/${uuid}/`);
    return response.data;
  } catch (error) {
    throw error;
  }
}


export async function CreateReturnReceipt(formData) {
  try {
    const response = await api.post("sales/return-receipt/create/", formData);
    return response.data;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export async function ArchiveReturnReceipt(id, id_list) {
  try {
    let response;
    if (id_list) {
      response = await api.post("sales/return-receipt/archive/", {
        id_list: id_list,
      });
    } else {
      response = await api.get(`sales/return-receipt/archive/?id=${id}`);
    }
    return response;
  } catch (error) {
    showAlert(error.response.data.message);
  }
}

export const SALUTATIONS_OPTIONS = [
  { value: "mr", label: "Mr." },
  { value: "mrs", label: "Mrs." },
  { value: "ms", label: "Ms." },
  { value: "miss", label: "Miss" },
  { value: "dr", label: "Dr." },
  { value: "prof", label: "Prof." },
  { value: "rev", label: "Rev." },
  { value: "sir", label: "Sir" },
];

export async function getCustomerOptions() {
  try {
    const response = await api.get("customer/options/");
    return response.data.data;
  } catch (error) {
    console.log(error);
    return {};
  }
}

export const getSalesByCustomer = async (params) => {
  try {
    const response = await api.get(
      `reports/sales-by-customer/`, // ✅ FIXED
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sales by customer:", error);
    throw error;
  }
};

export const getCustomerSalesDetail = async (customer_id, params) => {
  try {
    const response = await api.get(
      `reports/sales-by-customer/${customer_id}/`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching customer detail:", error);
    throw error;
  }
};

export const getSalesByItem = async (params) => {
  try {
    const response = await api.get(
      `reports/sales-by-item/`, // ✅ FIXED
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sales by item:", error);
    throw error;
  }
};

export const getSalesByItemDetail = async (item_id, params) => {
  try {
    const response = await api.get(`reports/sales-by-item/${item_id}/`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching item detail:", error);
    throw error;
  }
};

export const getSalesSummary = async (params) => {
  try {
    const response = await api.get(`reports/sales-summary/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales summary:", error);
    throw error;
  }
};

export const getSalesBySalesPerson = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-salesperson/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales by salesperson:", error);
    throw error;
  }
};
export const getSalesBySalesPersonDetail = async (salesPersonUuid, params) => {
  try {
    const response = await api.get(
      `reports/sales-by-sales-person-detail/${salesPersonUuid}/`,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching sales by salesperson detail:", error);
    throw error;
  }
};

export const getProfitByItem = async (params) => {
  try {
    const response = await api.get(`reports/profit-by-item/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching profit by item:", error);
    throw error;
  }
};

export const getCustomerOutstanding = async (params) => {
  try {
    const response = await api.get(`reports/customer-outstanding/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching customer outstanding:", error);
    throw error;
  }
};

export const getCollectionReport = async (params) => {
  try {
    const response = await api.get(`reports/collection-report/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching collection report:", error);
    throw error;
  }
};

export const getIncentiveReport = async (params) => {
  try {
    const response = await api.get(`reports/incentive-report/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching incentive report:", error);
    throw error;
  }
};

export const getTargetVsAchievementReport = async (params) => {
  try {
    const response = await api.get(`reports/target-vs-achievement/`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching target vs achievement report:", error);
    throw error;
  }
};

export const getRouteWiseSalesReport = async (params) => {
  try {
    const response = await api.get(`reports/route-wise-sales/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching route wise sales report:", error);
    throw error;
  }
};

export const checkQuickSale = async (data) => {
  try {
    const response = await api.post(`sales/quick-sale/check/`, data);
    return response.data;
  } catch (error) {
    console.error("Error fetching quick sale:", error);
    throw error;
  }
};

export const completeQuickSale = async (data) => {
  try {
    const response = await api.post(`sales/quick-sale/create/`, data);
    return response.data;
  } catch (error) {
    console.error("Error completing quick sale:", error);
    throw error;
  }
};

export const exportSalesSummary = async (params) => {
  try {
    const response = await api.get(`reports/sales-summary/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting sales summary:", error);
    throw error;
  }
};

export const exportSalesByCustomer = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-customer/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting sales by customer:", error);
    throw error;
  }
};

export const exportCustomerSalesDetail = async (customer_id, params) => {
  try {
    const response = await api.get(
      `reports/sales-by-customer/${customer_id}/export/`,
      { params, responseType: "blob" },
    );
    return response.data;
  } catch (error) {
    console.error("Error exporting customer sales detail:", error);
    throw error;
  }
};

export const exportSalesByItem = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-item/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting sales by item:", error);
    throw error;
  }
};

export const exportSalesByItemDetail = async (item_id, params) => {
  try {
    const response = await api.get(`reports/sales-by-item/${item_id}/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting sales by item detail:", error);
    throw error;
  }
};

export const exportSalesBySalesPerson = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-salesperson/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting sales by salesperson:", error);
    throw error;
  }
};

export const exportSalesBySalesPersonDetail = async (
  salesPersonUuid,
  params,
) => {
  try {
    const response = await api.get(
      `reports/sales-by-sales-person-detail/${salesPersonUuid}/export/`,
      { params, responseType: "blob" },
    );
    return response.data;
  } catch (error) {
    console.error("Error exporting sales by salesperson detail:", error);
    throw error;
  }
};

export const exportProfitByItem = async (params) => {
  try {
    const response = await api.get(`reports/profit-by-item/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting profit by item:", error);
    throw error;
  }
};

export const exportCustomerOutstanding = async (params) => {
  try {
    const response = await api.get(`reports/customer-outstanding/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting customer outstanding:", error);
    throw error;
  }
};

export const exportCollectionReport = async (params) => {
  try {
    const response = await api.get(`reports/collection-report/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting collection report:", error);
    throw error;
  }
};

export const exportIncentiveReport = async (params) => {
  try {
    const response = await api.get(`reports/incentive-report/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting incentive report:", error);
    throw error;
  }
};

export const exportTargetVsAchievementReport = async (params) => {
  try {
    const response = await api.get(`reports/target-vs-achievement/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting target vs achievement report:", error);
    throw error;
  }
};

export const exportRouteWiseSalesReport = async (params) => {
  try {
    const response = await api.get(`reports/route-wise-sales/export/`, {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting route wise sales report:", error);
    throw error;
  }
};

export const getLastVisited = async () => {
  try {
    const response = await api.get(`reports/last-visited/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching last visited:", error);
    throw error;
  }
};

export const updateLastVisited = async (report_name) => {
  try {
    const response = await api.post(`reports/last-visited/`, { report_name });
    return response.data;
  } catch (error) {
    console.error("Error updating last visited:", error);
    throw error;
  }
};

export async function exportTrialBalance(params) {
  try {
    const response = await api.get("/reports/trial-balance/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting trial balance:", error);
    throw error;
  }
}

export async function exportProfitAndLoss(params) {
  try {
    const response = await api.get("/reports/profit-and-loss/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting profit and loss:", error);
    throw error;
  }
}

export async function exportBalanceSheet(params) {
  try {
    const response = await api.get("/reports/balance-sheet/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting balance sheet:", error);
    throw error;
  }
}

export async function exportAgedReceivables(params) {
  try {
    const response = await api.get("/reports/aged-receivables/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting aged receivables:", error);
    throw error;
  }
}

export async function exportAgedPayables(params) {
  try {
    const response = await api.get("/reports/aged-payables/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting aged payables:", error);
    throw error;
  }
}

export async function exportAgedReceivablesDetail(params) {
  try {
    const response = await api.get("/reports/aged-receivables/detail/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting aged receivables detail:", error);
    throw error;
  }
}

export async function exportAgedPayablesDetail(params) {
  try {
    const response = await api.get("/reports/aged-payables/detail/export/", {
      params,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting aged payables detail:", error);
    throw error;
  }
}

export const downloadSalesByCustomer = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-customer/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading sales by customer PDF:", error);
    throw error;
  }
};

export const downloadCustomerSalesDetail = async (customer_id, params) => {
  try {
    const response = await api.get(
      `reports/sales-by-customer/${customer_id}/pdf/`,
      {
        params: { ...params, download: "1" },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading customer sales detail PDF:", error);
    throw error;
  }
};

export const downloadSalesByItem = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-item/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading sales by item PDF:", error);
    throw error;
  }
};

export const downloadSalesByItemDetail = async (item_id, params) => {
  try {
    const response = await api.get(`reports/sales-by-item/${item_id}/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading sales by item detail PDF:", error);
    throw error;
  }
};

export const downloadSalesSummary = async (params) => {
  try {
    const response = await api.get(`reports/sales-summary/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading sales summary PDF:", error);
    throw error;
  }
};

export const downloadSalesBySalesPerson = async (params) => {
  try {
    const response = await api.get(`reports/sales-by-salesperson/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading sales by salesperson PDF:", error);
    throw error;
  }
};

export const downloadSalesBySalesPersonDetail = async (
  sales_person_uuid,
  params,
) => {
  try {
    const response = await api.get(
      `reports/sales-by-sales-person-detail/${sales_person_uuid}/pdf/`,
      {
        params: { ...params, download: "1" },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error downloading sales by salesperson detail PDF:", error);
    throw error;
  }
};

export const downloadProfitByItem = async (params) => {
  try {
    const response = await api.get(`reports/profit-by-item/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading profit by item PDF:", error);
    throw error;
  }
};

export const downloadCustomerOutstanding = async (params) => {
  try {
    const response = await api.get(`reports/customer-outstanding/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading customer outstanding PDF:", error);
    throw error;
  }
};

export const downloadCollectionReport = async (params) => {
  try {
    const response = await api.get(`reports/collection-report/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading collection report PDF:", error);
    throw error;
  }
};

export const downloadIncentiveReport = async (params) => {
  try {
    const response = await api.get(`reports/incentive-report/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading incentive report PDF:", error);
    throw error;
  }
};

export const downloadTargetVsAchievementReport = async (params) => {
  try {
    const response = await api.get(`reports/target-vs-achievement/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading target vs achievement report PDF:", error);
    throw error;
  }
};

export const downloadRouteWiseSalesReport = async (params) => {
  try {
    const response = await api.get(`reports/route-wise-sales/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading route wise sales report PDF:", error);
    throw error;
  }
};

export const downloadTrialBalance = async (params) => {
  try {
    const response = await api.get(`reports/trial-balance/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading trial balance PDF:", error);
    throw error;
  }
};

export const downloadProfitAndLoss = async (params) => {
  try {
    const response = await api.get(`reports/profit-and-loss/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading profit and loss PDF:", error);
    throw error;
  }
};

export const downloadBalanceSheet = async (params) => {
  try {
    const response = await api.get(`reports/balance-sheet/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading balance sheet PDF:", error);
    throw error;
  }
};

export const downloadAgedReceivables = async (params) => {
  try {
    const response = await api.get(`reports/account-receivable/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading aged receivables PDF:", error);
    throw error;
  }
};

export const downloadAgedReceivablesDetail = async (params) => {
  try {
    const response = await api.get(`reports/account-receivable/detail/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading aged receivables detail PDF:", error);
    throw error;
  }
};

export const downloadAgedPayables = async (params) => {
  try {
    const response = await api.get(`reports/account-payable/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading aged payables PDF:", error);
    throw error;
  }
};

export const downloadAgedPayablesDetail = async (params) => {
  try {
    const response = await api.get(`reports/account-payable/detail/pdf/`, {
      params: { ...params, download: "1" },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading aged payables detail PDF:", error);
    throw error;
  }
};

export const printPdf = async (apiCall, params = {}, ...args) => {
  try {
    const response = await apiCall(...args, params);

    // response itself is the Blob directly
    const blob = response instanceof Blob
      ? response
      : new Blob([response], { type: "application/pdf" });

    const url = URL.createObjectURL(blob);

    const iframe = document.createElement("iframe");
    iframe.style.cssText = "position:fixed; top:-10000px; left:-10000px; width:1px; height:1px;";
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        } catch (e) {
          window.open(url, "_blank");
        } finally {
          setTimeout(() => {
            document.body.removeChild(iframe);
            URL.revokeObjectURL(url);
          }, 1000);
        }
      }, 500);
    };

  } catch (error) {
    console.error("Print failed:", error);
  }
};
